export default __webpack_public_path__ + "static/media/fireBettle.be04eaf2.jpeg";